import styled from 'styled-components';

export const Container = styled.div`
    position: fixed;
    right: 0;
    top: 0;
    padding: 30px;
    z-index: 9999;
`;

